__turbopack_context__.v({
  "container": "trip-section-module__vo1uiG__container",
  "sectionHeading": "trip-section-module__vo1uiG__sectionHeading",
});
